<!--
<div class="fixed inset-0 bg-white bg-opacity-95 z-50 transform transition-opacity duration-300" [ngClass]="{'opacity-100': showSearch, 'opacity-0 pointer-events-none': !showSearch}">
  <div class="max-w-4xl mx-auto p-6">
    <div class="flex items-center space-x-4">
      &lt;!&ndash; Search Input &ndash;&gt;
      <input #searchInput type="text" (input)="onSearchInput($event)" placeholder="Type to search..."
             class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300 text-gray-600">

      &lt;!&ndash; Close Button &ndash;&gt;
      <div class="search-tools">
        <button (click)="onCloseSearch(searchInput)" class="text-gray-600 hover:text-gold transition duration-300">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    &lt;!&ndash; Search Results &ndash;&gt;
    <div class="search-results mt-6" *ngIf="products && products.length > 0">
      <div class="products-list relative">
        &lt;!&ndash; Skeleton Loader &ndash;&gt;

        &lt;!&ndash; Product List with Uniform Dimensions &ndash;&gt;
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 w-full max-w-6xl mx-auto p-4" #productGrid>
          <app-my-item-product *ngFor="let product of products" [product]="product" [displayMode]="'grid'" ></app-my-item-product>
        </div>
      </div>

      &lt;!&ndash;
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              <app-my-item-product (click)="onCloseSearch(searchInput)" class="p-2 rounded-lg hover:bg-gold hover:bg-opacity-10 transition duration-300" *ngFor="let product of products" [product]="product">
                <a routerLink="/products/{{product.id}}" class="text-gold hover:text-gold-dark transition duration-300">{{product.name}}</a>
              </app-my-item-product>
            </div>
      &ndash;&gt;
    </div>
  </div>
</div>
-->



<div
  class="fixed inset-0 bg-white bg-opacity-95 z-50 transform transition-opacity duration-300 overflow-y-auto"
  [ngClass]="{'opacity-100': showSearch, 'opacity-0 pointer-events-none': !showSearch}"
>
  <div class="max-w-4xl mx-auto p-6 min-h-screen flex flex-col">
    <div class="flex items-center space-x-4">
      <!-- Search Input -->
      <input
        #searchInput
        type="text"
        (input)="onSearchInput($event)"
        placeholder="Type to search..."
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300 text-gray-600"
      >

      <!-- Close Button -->
      <div class="search-tools">
        <button
          (click)="onCloseSearch(searchInput)"
          class="text-gray-600 hover:text-gold transition duration-300"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Search Results -->
    <div class="search-results mt-6 flex-1" *ngIf="products && products.length > 0">
      <div class="products-list relative">
        <!-- Product List with Uniform Dimensions -->
        <div
          class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 w-full max-w-6xl mx-auto p-4"
          #productGrid
        >
          <app-my-item-product
            (click)="onCloseSearch()"
            *ngFor="let product of products"
            [product]="product"
            [displayMode]="'grid'"
          ></app-my-item-product>
        </div>
      </div>
    </div>
  </div>
</div>
